import { userPartialUpdaterBuilder } from "../userPartialUpdaterBuilder";
import { UserNameFormik, USER_NAME_MESSENGER_CONTEXT, validationUserNameSchema } from "./UserNameForm";

export const UserNameFormEdit = userPartialUpdaterBuilder(UserNameFormik, {
  validationSchema: validationUserNameSchema,
  messangerContext: USER_NAME_MESSENGER_CONTEXT,
});
